









































































































import { Component, Vue } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import mapStore from "@/store/mapStore";
import userStore from "@/store/userStore";
import format from "date-fns/format";
import { DATE_PICKER_FORMAT } from "@/Constants";
import { dateLongExact } from "@/filters/DateExact";
import MapAddressSearch from "@/components/Map/MapAddressSearch.vue";
import DatePicker from "@/components/Forms/DatePicker.vue";

@Observer
@Component({ components: { MapAddressSearch, DatePicker } })
class MapFilters extends Vue {
  mapStore = mapStore;
  userStore = userStore;
  maxDate = format(new Date(), DATE_PICKER_FORMAT);
  collectionDateMenu = false;

  get formattedCollectionDate() {
    const d: string | Date | undefined = this.mapStore.date;
    if (!d) return "";
    // Use Object.prototype.toString.call for robust Date check
    const iso = Object.prototype.toString.call(d) === "[object Date]" ? ((d as unknown) as Date).toISOString() : String(d);
    return dateLongExact(iso);
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  get isLandUseVisible() {
    return (this.$parent as any).isLandUseVisible;
  }

  set isLandUseVisible(value: boolean) {
    (this.$parent as any).toggleLandUse();
  }
  /* eslint-enable @typescript-eslint/no-explicit-any */
}

export default MapFilters;
